import React, { useState, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import Gtm from '../../utils/gtm'

import Container from '../ui/BlueChipSignup/Container'
import { loggingEnabled } from '../../utils/logging'

export const BlueChipFormNew = props => {
  const { body } = props

  const useStyles = createUseStyles(theme => ({
    container: {
      padding: '30px 15px',
      '@media (max-width: 700px)': {
        boxSizing: 'border-box',
        padding: '30px 15px',
      },
    },
    innerCont: { margin: '0 auto', width: '100%', maxWidth: '1220px' },
    title: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '15px',
      marginTop: 0,
      color: theme.colors.main,
    },
    details: {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 400,
      textAlign: 'left',
      marginBottom: '30px',
      marginTop: 0,
      maxWidth: '560px',
      color: '#000',
      textAlign: 'left',
      '@media (max-width: 600px)': {
        fontSize: '15px',
        lineHeight: 1.4,
      },
    },
    flexCont: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: 0,
      },
    },
    flexContFull: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: 20,
    },
    formsec: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 600px)': {
        flexDirection: 'column',
      },
    },
    formarea: {
      margin: '0 auto',
      width: '100%',
      maxWidth: 700,
    },
    tollarea: {
      width: 380,
      borderRadius: 20,
      backgroundColor: '#F5F5F5',
      padding: 40,
      boxSizing: 'border-box',
      '@media (max-width: 600px)': {
        width: '100%',
        marginTop: 60,
      },
    },
    tollareaTitle: {
      color: theme.colors.main,
      fontSize: 18,
      lineHeight: 1.3,
      marginBottom: 20,
    },
    tollareaNumber: {
      color: '#2D2D2D',
      fontSize: 15,
      lineHeight: 1.3,
      marginBottom: 10,
      '& a': {
        color: theme.colors.main,
      },
      '& span': {
        '&:nth-child(2)': {
          marginLeft: 3,
        },
      },
    },
    buttonPrimary: {
      display: 'inline-block',
      padding: '14px 0',
      border: 'none',
      color: '#fff',
      backgroundColor: theme.colors.orange,
      borderRadius: '15px',
      lineHeight: '18px',
      fontSize: '18px',
      fontWeight: 700,
      textDecoration: 'none',
      width: 215,
      '@media (max-width: 600px)': {
        display: 'block',
        width: '100%',
      },
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
      '&:disabled, &[disabled]': {
        backgroundColor: '#cccccc',
        borderColor: '#cccccc',
        color: '#666666',
      },
    },
  }))
  const classes = useStyles()
  const formMessages = useRef(null)
  const gtm = new Gtm(loggingEnabled)

  const [formStatus, setFormStatus] = useState('in-progress')
  const [newMemberNumber, setNewMemberNumber] = useState('')
  const [isPromoForm, setIsPromoForm] = useState(false)
  const isPanelForm = false

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        <div className={classes.formsec}>
          <div className={classes.formarea}>
            <div ref={formMessages}></div>

            {body !== '' && <div className={classes.details}>{body}</div>}

            {formStatus === 'complete' && (
              <div
                style={{
                  border: '1px solid #F7F7F7',
                  boxShadow: '1px 5px 15px rgba(0, 0, 0, 0.15)',
                  borderRadius: 20,
                  padding: '50px 25px',
                  margin: '25px 0',
                }}
              >
                <div style={{ fontSize: '20px', lineHeight: 1.3, textAlign: 'center' }}>
                  Thank you for joining the Blue Chip Member Program, your membership number is
                  <br />
                  <div style={{ fontWeight: 'bold', paddingTop: 20, fontSize: 24 }}>
                    {newMemberNumber}
                  </div>
                </div>
                <div style={{ textAlign: 'center', paddingTop: 40 }}>
                  <div
                    style={{
                      backgroundColor: '#11BA22',
                      color: '#fff',
                      borderRadius: '18px',
                      padding: '18px 40px',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    <SVG
                      name="TickCircle"
                      width={16}
                      height={16}
                      colorOne="#11BA22"
                      colorTwo="#fff"
                    />
                    <span style={{ display: 'inline-block', paddingLeft: 5 }}>Success</span>
                  </div>
                </div>
              </div>
            )}

            <Container
              isPanelForm={isPanelForm}
              isPromoForm={isPromoForm}
              setNewMemberNumber={setNewMemberNumber}
              setFormStatus={setFormStatus}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlueChipFormNew
